import { render, staticRenderFns } from "./Ekwateur.vue?vue&type=template&id=22127834&scoped=true"
import script from "./Ekwateur.vue?vue&type=script&lang=js"
export * from "./Ekwateur.vue?vue&type=script&lang=js"
import style0 from "./Ekwateur.vue?vue&type=style&index=0&id=22127834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22127834",
  null
  
)

export default component.exports